import React from "react";
import JokeList from "./JokeList";
import "./App.css";

function App (){
  
    return (
      <div className='App'>
        <JokeList />
      </div>
    );
  
}

export default App;
